module.exports = __webpack_public_path__ + "img/calendar-colored.9d0b5a07.svg";